export default __webpack_public_path__ + "static/media/githubIcon.540731f6.png";